import { CalendarRangePicker, TechCardStatuses, useResetForm } from '@/shared';
import { forwardRef, useImperativeHandle } from 'react';
import { FilterFormHandle, FilterTechMapProps } from '../filter-modal.types';
import { ProductNamingLazySelect } from '../fields/name-select';
import { FormProvider, useForm } from 'react-hook-form';
import { TechCardsFiltersNullableArg } from '@/entities/tables/tech-card';
import { GroupSelect } from '../fields/group-select';
import { CurrentOperationSelect } from '../fields/current-operation-select';
import { ProductSymbolLazySelect } from '../fields/symbol-select';
import { CheckboxGroupStatus } from '../fields/status-checkbox-group';
import { WastedRadioGroup } from '../fields/wasted-radio-group';
import styles from '../filter.module.scss';
import { productTechMapDefaults } from '../../model/tech-map-defaults';
import { NumForProductTechCardSelect } from '../fields/num-select';
import { CommentedRadioGroup } from '../fields/сommented-radio-group';

export const FilterProductTechMap = forwardRef<FilterFormHandle, FilterTechMapProps>(
	({ defaultValue, onSubmit }, ref) => {
		const formProps = useForm<TechCardsFiltersNullableArg>({
			defaultValues: productTechMapDefaults(defaultValue),
		});

		const { handleSubmit, getValues, setValue } = formProps;
		const { handleResetForm } = useResetForm(getValues, setValue);

		useImperativeHandle(ref, () => ({
			handleResetForm: () => {
				handleResetForm();
				setValue('createdAtFrom', null);
				setValue('createdAtTo', null);
				setValue('storageAtFrom', null);
				setValue('storageAtTo', null);
				handleSubmit(onSubmit)();
			},
			requestSubmit() {
				handleSubmit(onSubmit)();
			},
		}));

		const selectCreatedDates = (firstDate: string, secondDate: string) => {
			setValue('createdAtFrom', firstDate);
			setValue('createdAtTo', secondDate);
		};
		const selectSGDDates = (firstDate: string, secondDate: string) => {
			setValue('storageAtFrom', firstDate);
			setValue('storageAtTo', secondDate);
		};

		return (
			<form className={styles['form']} onSubmit={handleSubmit(onSubmit)}>
				<FormProvider {...formProps}>
					<GroupSelect />
					<ProductNamingLazySelect />
					<NumForProductTechCardSelect />
					<CurrentOperationSelect />
					<ProductSymbolLazySelect />
					<CheckboxGroupStatus
						statuses={[
							TechCardStatuses.progress,
							TechCardStatuses.accepted_at_sgd,
							TechCardStatuses.partially_issued,
							TechCardStatuses.canceled,
							TechCardStatuses.released,
							TechCardStatuses.completed,
							TechCardStatuses.wasted,
						]}
					/>
					<WastedRadioGroup />
					<CommentedRadioGroup />
					<CalendarRangePicker
						textLabel="Дата создания"
						setDates={selectCreatedDates}
						defaultValue={{
							from: defaultValue?.createdAtFrom,
							to: defaultValue?.createdAtTo,
						}}
					/>
					<CalendarRangePicker
						textLabel="Дата принятия на СГД"
						setDates={selectSGDDates}
						defaultValue={{
							from: defaultValue?.storageAtFrom,
							to: defaultValue?.storageAtTo,
						}}
					/>
				</FormProvider>
			</form>
		);
	},
);
